/**
 * Created by Languagenut on 18/04/2019.
 */


import React  from 'react';
import {ButtonGroup , ProgressBar , Table , Badge  , Button} from 'react-bootstrap'
import Constants from '../../../constants.js';
import {StudentsService} from '../../../services';
import {UserStore} from '../../../store';
import Translation from '../../../store/internationalization-store.js';
import Checkbox from '../../checkbox.js';

class UploadStudentsComfirmation extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {
            errors:[],
            warnings:[],
            summary:[],
            loading:true
        };

        this.props.data.settings = {
            generateUsernames:false
        };
    }

    hasConflicts(){
        let conflicts = true;

        for(var idx = 0 ; idx < this.props.data.students.length; idx++)
        {
            if(this.props.data.students[idx].conflict)
            {
                conflicts = false;
            }
        }


        this.setState({
            no_conflicts:conflicts
        })
    }


    componentDidMount(){
        StudentsService.getExistingStudents(this.props.data.students.map(function(student){
            return student.name;
        }))
    }

    componentWillMount(){
        UserStore.on(Constants.EXISITNG_ACCOUNT_STUDENTS , ()=>{

            for(var i = 0 ; i < UserStore.exisitingStudents.length; i++) {
                for (var j = 0; j < this.props.data.students.length; j++) {
                    if (UserStore.exisitingStudents[i].rawName == this.props.data.students[j].name) {
                        this.props.data.students[j].conflict = true;
                    }
                }
            }

            this.setState({
                exsisting:UserStore.exisitingStudents || [],
                loading:false,
            })

            this.hasConflicts();
        })
    }

    resolveConflict(id , uid , action){
        this.props.data.students[id].state     = action;
        this.props.data.students[id].uid       = uid;
        this.props.data.students[id].conflict  = false;
        this.hasConflicts();
    }

    all(method)
    {
        for(var i = 0 ; i < this.state.exsisting.length; i++){
            for(var j = 0 ; j < this.props.data.students.length; j++)
            {
                if(this.state.exsisting[i].rawName == this.props.data.students[j].name)
                {
                    this.resolveConflict(j , this.state.exsisting[i].uid ,method)
                }
            }
        }

       // this.setState({update:true})
    }

    renderRows(){

        var r = [];

        for(var i = 0 ; i < this.state.exsisting.length; i++)
        {
            for(var j = 0 ; j < this.props.data.students.length; j++)
            {
                if(this.state.exsisting[i].rawName == this.props.data.students[j].name)
                {
                    console.log(this.props.data.students[j])
                    console.log(this.props.data.students[j].state == 'add')
                    r.push(<tr>
                        <td>{this.state.exsisting[i].name}</td>
                        <td>{this.state.exsisting[i].username}</td>
                        <td>{this.state.exsisting[i].password}</td>
                        <td>{this.state.exsisting[i].classes.map(function(object){ return <Badge>{object.name}</Badge>})}</td>
                        <td >
                            <Checkbox
                                type="checkbox"
                                checked={this.props.data.students[j].state == 'new'  ? true : false}
                                onChange={this.resolveConflict.bind(this , j , this.state.exsisting[i].uid ,'new')}
                                name="Add"
                                />
                        </td>
                        <td >
                            <Checkbox
                                type="checkbox"
                                name="Add"
                                checked={this.props.data.students[j].state == 'add'  ? true : false}
                                onChange={this.resolveConflict.bind(this , j , this.state.exsisting[i].uid ,'add')}
                                />
                        </td>
                    </tr>);
                }

            }

        }

        return r;
    }


    render(){


        if(this.state.loading) return <ProgressBar animated now={100} />
        if(this.state.no_conflicts){
            this.props.forceAdvance();
            return null;
        }

        return  <div>

            <b>{Translation.get(12726 , 'The following student names have already been found within your account. Are these new or existing students you wish to add to this class?')}</b>

            <br/>
            <br/>
            <ButtonGroup aria-label="Basic example">
                <Button onClick={this.all.bind(this , 'new')}>{Translation.get(12727 , 'Make all new')}</Button>
                &nbsp;&nbsp;
                <Button onClick={this.all.bind(this , 'add')}>{Translation.get(12728 , 'Add all existing')}</Button>
            </ButtonGroup>

            <br/>
            <br/>
            <Table size="sm"  bordered={false}  responsive>
                <tr>
                    <th colspan={4}></th>
                    <th>
                        {Translation.get(12729 , 'Make new student')}
                    </th>
                    <th>
                        {Translation.get(12730 , 'Add existing student')}
                    </th>
                </tr>
               {this.renderRows.bind(this)()}
        </Table>
        </div>

    }


}


export default {
    name: function() {return Translation.get('1017' ,'Summary' )},
    icon:<i class="fa-2x fas fa-file-alt"></i>,
    title:null,
    onSubmit: function (done){
        done();
    },
    component: UploadStudentsComfirmation
}